export default {
  Home: {
    list: '/',
  },
  Produits: {
    list: '/:id',
  },
  Widgets: {
    list: '/widgets/:id',
  },
}
